<template>
  <Chip
    v-if="content.launchData?.openedAt && !content.launchData?.completedAt"
    :size="ChipSize.SM"
    :variant="ChipVariant.FILLED"
    :icon="IconName.EYE"
    :color="ChipColor.SECONDARY"
    class="w-fit self-end"
  >
    {{ $t('content.opened') }}
  </Chip>
  <Chip
    v-if="content.launchData?.completedAt"
    :size="ChipSize.SM"
    :variant="ChipVariant.FILLED"
    :icon="IconName.CHECK"
    :color="ChipColor.SUCCESS"
    class="w-fit self-end"
  >
    {{ $t('content.completed') }}
  </Chip>
</template>
<script setup lang="ts">
import { IconName } from '@exfluential/ui';
import { Chip, ChipColor, ChipSize, ChipVariant } from '~/components/chip';
import { ContentDto } from '~/api/contents';

type Props = {
  content: ContentDto;
};

defineProps<Props>();
</script>
